import { render, staticRenderFns } from "./yearlyInspect_addoredit.vue?vue&type=template&id=590ac3ea&"
import script from "./yearlyInspect_addoredit.vue?vue&type=script&lang=js&"
export * from "./yearlyInspect_addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports